import './assets/scss/main.scss';
import HomePage from '../src/pages/home';

function App() {
  return (
    <HomePage />
  );
}

export default App;